import { Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getCompany, getInternStudent } from "../api/crud";
import { optionsBranch } from "../data/branch-data";
import { convertDateToString, convertTime } from "../utils/function";
import { GiFactory } from "react-icons/gi";
import Pagination from "react-js-pagination";

const CompanyDetail = () => {
  const [internStudentList, setInternStudentList] = useState([]);
  const [internRequest, setInternRequest] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [sortData, setSortData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [studentSelected, setStudentSelected] = useState(null);
  const [companyLists, setCompanyLists] = useState([]);
  const [isNameSortAcc, setIsNameSortAcc] = useState(true);

  const matchOptions = (options, value = "") => {
    const match = options.find((item) => item.value == value);

    return match ? match.label : "-";
  };

  //   const onHandleSortName = () => {
  //     const mockupArray = [...filterList];
  //     if (isNameSortAcc) {
  //       const sortedData = mockupArray.sort((a, b) =>
  //         ("" + a.name).localeCompare(b.name, "th")
  //       );

  //       setSortData(sortedData);
  //     } else {
  //       const sortedData = mockupArray.sort((a, b) =>
  //         ("" + b.name).localeCompare(a.name, "th")
  //       );

  //       setSortData(sortedData);
  //     }
  //     setIsNameSortAcc(!isNameSortAcc);
  //   };

  const getCompanyList = () => {
    getCompany()
      .then((res) => {
        setCompanyLists(res);
        setFilterList(res);
        setSortData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSearchChange = (ev) => {
    setSearchTerm(ev.target.value);

    const results = companyLists.filter((item) => {
      return (
        item.id.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.branch.toLowerCase().includes(ev.target.value.toLowerCase())
      );
    });

    setFilterList(results);
  };

  const getInternStudentList = () => {
    getInternStudent()
      .then((res) => {
        setInternStudentList(res);
        setFilterList(res);

        const unRequest = res.filter(
          (el) => el.status_id > 0 && el.status_id <= 3
        );

        setInternRequest(unRequest);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getInternStudentList();
    getCompanyList();
  }, []);

  const generateStatus = (item) => {
    if (item.status_id == 0) {
      return <span className="badge bg-success">ลงทะเบียนแล้ว</span>;
    } else if (item.status_id == 1) {
      return <span className="badge bg-success">ยื่นคำขอแล้ว</span>;
    } else if (item.status_id == 2) {
      return <span className="badge bg-warning">ยื่นคำขอ ด้วยบริษัทใหม่</span>;
    } else if (item.status_id == 3) {
      return <span className="badge bg-success">อนุมัติคำขอฝึกงานแล้ว</span>;
    }
  };

  const displayTable = (
    <>
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <h5 className="card-title mb-0">รายชื่อนักศึกษา</h5>
          <input
            type="text"
            style={{ maxWidth: 300 }}
            className="form-control"
            placeholder="ค้นหา"
            onChange={onSearchChange}
            value={searchTerm}
          />
        </div>
      </div>
      <div className="overflow-auto">
        <table
          id="datatables-dashboard-projects"
          className="table table-striped my-0 table-hover"
        >
          <thead>
            <tr className="text-nowrap">
              <th>รหัสสถานประกอบการ</th>
              <th>ชื่อสถานประกอบการ</th>
              <th>ที่อยู่</th>
            </tr>
          </thead>
          <tbody>
            {filterList.length &&
              filterList.map((item) => {
                return (
                  <tr
                    className="text-nowrap"
                    key={item.id}
                    onClick={() => {
                      setStudentSelected(item);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    role="button"
                  >
                    <td>{item.id}</td>
                    <td>
                      <div className="text-wrap">{item.name}</div>
                    </td>
                    <td>
                      <div className="text-wrap">
                        {item?.address} ต.
                        {item?.subdistrict} อ.
                        {item?.district} จ.
                        {item?.province} {item?.zip}
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  const displayProfile = (
    <div className="card-body shadow-lg">
      <div className="row g-0">
        <div
          className="fw-bold"
          role="button"
          onClick={() => setStudentSelected(null)}
        >
          X
        </div>
        <div className="col-12 text-center">
          <GiFactory size="5rem" />
        </div>
      </div>
      <table className="table table-sm my-2">
        <tbody>
          <tr>
            <th>ชื่อ</th>
            <td>{studentSelected?.name}</td>
          </tr>

          <tr>
            <th>ที่อยู่</th>
            <td>
              {studentSelected?.address} ต.
              {studentSelected?.subdistrict} อ.
              {studentSelected?.district} จ.
              {studentSelected?.province} {studentSelected?.zip}
            </td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{studentSelected?.email}</td>
          </tr>
          <tr>
            <th>เบอร์โทร</th>
            <td>{studentSelected?.st_tel}</td>
          </tr>
          <tr>
            <th>สาขาที่รับ</th>
            <td>{studentSelected?.branch}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const displayDashboard = (
    <div className="main">
      <main className="content">
        <div className="container-fluid p-0">
          <div className="row mb-2 mb-xl-3">
            <div className="col-auto d-none d-sm-block">
              <h3>รายชื่อสถานประกอบการ</h3>
            </div>
          </div>

          <div className="card flex-fill">
            <div className="row">
              <div className={studentSelected ? "col-lg-8" : "col-lg-12"}>
                {displayTable}
              </div>
              <div className="col-lg-4">
                {studentSelected ? displayProfile : ""}
              </div>
            </div>

            {/* <div className="d-flex justify-content-between">
              <div>{displayTable}</div>
              <div>{displayProfile}</div>
            </div> */}
          </div>
        </div>
      </main>
    </div>
  );
  return <div>{displayDashboard}</div>;
};

export default CompanyDetail;
